import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { SelectOptionType } from '../../../../../../../../components/dialog/helper';
import { InputSelect } from '../../../../../../../../components/input/select';
import { PriceTriggerSubType } from '../../../../../../../../data-access/gql-types/graphql';
import { useTriggerFormContext } from '../../../../context/provider';

const TariffSelect: React.FC = () => {
  const { t } = useTranslation('channel-details');
  const { triggerId } = useParams<{ triggerId: string }>();
  const { priceConditionConfig, setPriceConditionConfig, removePriceCondition } = useTriggerFormContext();
  const subType = priceConditionConfig.subType;

  useEffect(() => {
    if (!triggerId) {
      setPriceConditionConfig((prev) => ({
        ...prev,
        subType: subType !== PriceTriggerSubType.Unknown ? subType : PriceTriggerSubType.Unknown,
      }));
    }
  }, [triggerId]);

  const tariffs: SelectOptionType<PriceTriggerSubType>[] = [
    { label: t('optimizer.configuration.tariff.dynamic'), value: PriceTriggerSubType.Dynamic },
    { label: t('optimizer.configuration.tariff.g13s'), value: PriceTriggerSubType.G13S },
  ];

  const handleChange = (val: PriceTriggerSubType) => {
    removePriceCondition();
    setPriceConditionConfig((prev) => ({ ...prev, subType: val }));
  };

  return (
    <div className="max-width-desktop w-full">
      <InputSelect
        onChange={handleChange}
        value={subType}
        options={tariffs}
        label={t('optimizer.configuration.tariff.label')}
      />
      {subType !== PriceTriggerSubType.Unknown && <hr className="m-b-24" />}
    </div>
  );
};

export default TariffSelect;
